import { AbstractCoroutine2jzyhqo91sb0o as AbstractCoroutine } from '../AbstractCoroutine.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { JobCancellationException2g3wpni5v5fkt as JobCancellationException } from '../Exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  close$default1evna6yun3t5h as close$default,
  ReceiveChannel24wu5e2tj9lbp as ReceiveChannel,
  SendChannel38sllbxw662ws as SendChannel,
} from './Channel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ChannelCoroutineClass;
function ChannelCoroutine() {
  if (ChannelCoroutineClass === VOID) {
    class $ extends AbstractCoroutine() {
      constructor(parentContext, _channel, initParentJob, active) {
        super(parentContext, initParentJob, active);
        this.h1c_1 = _channel;
      }
      qx(cause) {
        if (this.dx())
          return Unit_instance;
        var tmp;
        if (cause == null) {
          // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
          tmp = JobCancellationException().f15(null == null ? this.kw() : null, null, this);
        } else {
          tmp = cause;
        }
        this.sx(tmp);
      }
      u1b(cause, $super) {
        return this.rx(cause, ($super == null ? true : $super instanceof ChannelCoroutine()) ? $super : THROW_CCE());
      }
      sx(cause) {
        var exception = this.ix(cause);
        this.h1c_1.qx(exception);
        this.vx(exception);
      }
      z1a() {
        return this.h1c_1.z1a();
      }
      *g1b(element, $completion) {
        yield* this.h1c_1.g1b(element, $completion);
        return Unit_instance;
      }
      h1b(element) {
        return this.h1c_1.h1b(element);
      }
      q1b(cause) {
        return this.h1c_1.q1b(cause);
      }
      v1b(handler) {
        this.h1c_1.v1b(handler);
      }
      *j1b($completion) {
        return yield* this.h1c_1.j1b($completion);
      }
      p1() {
        return this.h1c_1.p1();
      }
    }
    protoOf($).s1b = close$default;
    initMetadataForClass($, 'ChannelCoroutine', VOID, VOID, [ReceiveChannel(), SendChannel()], [1, 0]);
    ChannelCoroutineClass = $;
  }
  return ChannelCoroutineClass;
}
//region block: exports
export {
  ChannelCoroutine as ChannelCoroutine12l2gxei4u780,
};
//endregion

//# sourceMappingURL=ChannelCoroutine.mjs.map
